import _cloneDeep from "lodash/cloneDeep";
import _isEmpty from "lodash/isEmpty";
import _omit from "lodash/omit";
import { useSelector } from "react-redux";
import { getFullName } from "utils";
import { filterCompanyVersions } from "../History/filterCompanyVersions";
import CompanyStakeholderTable from "./CompanyStakeholderTable";

export default function StakeholderDetails({
  companyId,
  isInchangesModule,
  dateFrom,
  dateTo,
  isHistory,
}) {
  const companyDashboardSlice = useSelector(
    (state) => state.companyDashboardSlice
  );

  const { latestVersion, previousVersion } = filterCompanyVersions({
    dateFrom,
    dateTo,
    company: companyDashboardSlice.company,
    companyOfficials: companyDashboardSlice.companyOfficials.items,
  });

  const { getCompanyOfficialsStatus } = companyDashboardSlice;
  const currentOfficials = companyDashboardSlice.companyOfficials.items.filter(
    (official) => official?.cessationStatus !== "Processed"
  );

  // Prepare companyOfficials based on isHistory flag
  let companyOfficials =
    isHistory && latestVersion.officials.length > 0
      ? latestVersion.officials
      : currentOfficials;

  const { totalCount } = companyDashboardSlice.companyOfficials;

  const shareAllotments = useSelector(
    (state) => state.shareAllotmentSlice?.allotments || []
  );

  const JSGroups = new Set();
  companyOfficials.forEach((item) => {
    if (item.JSGroupID) JSGroups.add(item.JSGroupID);
  });

  const allJS = [...JSGroups].map((id) => {
    const names = [];
    let combinedJS = {};
    companyOfficials.forEach((official) => {
      if (official.JSGroupID === id) {
        names.push(getFullName(official));
        if (official.sharesAllotted && official.sharesAllotted.length > 0)
          combinedJS.sharesAllotted = official.sharesAllotted;
        combinedJS = {
          ...combinedJS,
          ..._omit(_cloneDeep(official), ["sharesAllotted"]),
          designation: "Joint Shareholder",
          idType: "Joint Shareholder",
        };
        combinedJS.fullName = names.map((name, index) => {
          if (names.length === 2 && index === 0) {
            return `${name} & `;
          }
          if (names.length > 2 && index === names.length - 2) {
            return `${name} & `;
          }

          if (
            names.length > 2 &&
            index !== names.length - 2 &&
            index !== names.length - 1
          ) {
            return `${name}, `;
          }
          return name;
        });
      }
    });
    return combinedJS;
  });

  let data = [
    ...companyOfficials.filter((item) =>
      isInchangesModule
        ? ["Director Shareholder", "Shareholder"].includes(item.designation)
        : (item.designation === "Joint Shareholder" &&
            item.isDirector === "Yes") ||
          item.designation !== "Joint Shareholder"
    ),
    ...allJS.filter((item) => !_isEmpty(item)),
  ];
  return (
    <div className="mt-6">
      <CompanyStakeholderTable
        data={data}
        dateFrom={dateFrom}
        dateTo={dateTo}
        isHistory={isHistory}
        latestVersion={latestVersion.officials}
        previousVersion={previousVersion.officials}
        shareAllotments={shareAllotments}
        isInChangesModule={isInchangesModule}
        totalCount={totalCount}
        companyId={companyId}
        currentTab="stakeholderTab"
        isLoading={getCompanyOfficialsStatus.status === "loading"}
      />
    </div>
  );
}
